// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"663":"60c525bde99c12fa7a31","697":"4baac29bb69b31c7dc00"}[chunkId] + ".js";
};